'use client'
import Download from './Download'
import LanguageAndCurrency from './LanguageAndCurrency'
import Order from './Order'
import Theme from './Theme'
import User from './User'
import Wallet from './Wallet'
import { Authentication } from 'core/components/Authenticate'
import { Flex } from 'antd'
import SearchCoin from './SearchCoin'
import { useLocale } from 'core/components/Locale'
import styles from './styled.module.scss'
import Notify from './Notify'
import cls from 'classnames'
import SideNavIcon from './SideNav/SideNavIcon'
import LinkWallet from '@/components/Header/RightWarp/LinkWallet'
type TProp = {
  platform?: 'exchange' | 'web3Wallet'
}
export default function RightWarp({ platform = 'exchange' }: TProp) {
  const t = useLocale()
  const isExchange = platform === 'exchange'
  return (
    <Flex gap="20px" className="mr-5 whitespace-nowrap" align="center">
      {isExchange ? (
        <>
          <Authentication
            allow={() => (
              <>
                <div className="show-pc">
                  <Wallet />
                </div>
                <div className="show-pc">
                  <Order />
                </div>
                <div className="show-pc">
                  <Notify />
                </div>
              </>
            )}
            deny={({ login, register }) => (
              <Flex gap="20px" align="center">
                <div onClick={login} className={cls([styles.btn, 'hide-phone'])}>
                  {t('header_008')}
                </div>
                <div onClick={register} className={styles.btn_1}>
                  {t('header_009')}
                </div>
              </Flex>
            )}
          />
          <div className="show-pc">
            <SearchCoin />
          </div>
          <div className="hide-phone">
            <Download />
          </div>
        </>
      ) : (
        <LinkWallet />
      )}
      {isExchange && (
        <div className="show-pc">
          <Theme />
        </div>
      )}
      <div className="show-pc">
        <LanguageAndCurrency />
      </div>
      <User />
      <div className="hide-pc">
        <SideNavIcon />
      </div>
    </Flex>
  )
}
